module.exports = __webpack_public_path__ + "static/media/logo-gs.12b9d104.png";